import * as React from "react";
import { Suggestions, type BlockReceipt } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function SuggestionsDemo() {
  const [receipt, setReceipt] = React.useState<BlockReceipt | undefined>(undefined);

  return (
    <Section
      id="suggestions"
      title="Suggestions"
      description="Quick-reply / follow-up chips (INTERACTIVE). Renderer for the K2 `suggestions` block - props are `{ prompt?, suggestions: [{id, label, value?}], submit_to, receipt? }`. Clicking a chip emits the shared block-submit event keyed by block_id."
    >
      <VariantBlock label="Live chips -> settled receipt" caption="click a chip">
        <div className="w-full max-w-xl">
          <Suggestions
            prompt="You could ask:"
            suggestions={[
              { id: "s1", label: "Summarize this" },
              { id: "s2", label: "What changed?" },
              { id: "s3", label: "Show me the data", value: "Show me the underlying data table" },
            ]}
            receipt={receipt}
            onSelect={(chip) =>
              setReceipt({
                outcome: "success",
                summary: `You asked: "${chip.value ?? chip.label}"`,
                at: new Date().toISOString(),
              })
            }
          />
          {receipt ? (
            <button
              type="button"
              className="mt-3 text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground"
              onClick={() => setReceipt(undefined)}
            >
              Reset
            </button>
          ) : null}
        </div>
      </VariantBlock>

      <VariantBlock label="Pre-settled (history reload)">
        <div className="w-full max-w-xl">
          <Suggestions
            suggestions={[{ id: "s1", label: "Summarize this" }]}
            receipt={{ outcome: "success", summary: 'You asked: "Summarize this"', at: "2026-06-20T09:15:00Z" }}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
